import { useReimbursementRequestContext } from "../../../Contexts/ReimbursementRequestContext";
import PropTypes from "prop-types";

function ClaimType(props) {
  const { nextStep } = props;
  const {
    formData,
    setFormData
  } = useReimbursementRequestContext();

  const handleSelectClaimType = (claimType) => {
    let fields = {
      claimType: claimType
    }
    // if selected claim type is different from current, reset uploads
    if(formData.claimType !== claimType){
      fields = {
        ...fields,
        chargeSlip: null,
        officialReceipt: null,
        medicalCertificate: null,
        statementOfAccount: null,
        policeReport: null,
        opticalPrescription: null,
        dentalCertificate: null,
        opMedicinePrescription: null,
      }
    }
    // reset discharge date if claim type is changed from IP to another type
    if(formData.claimType === "In Patient (IP)" && claimType !== "In Patient (IP)"){
      fields = {
        ...fields,
        dischargeDate: null
      }
    }
    let newForm = {
      ...formData,
      ...fields
    };
    setFormData(newForm);
    nextStep();
  };

  return (
    <div className="p-4">
      <p className="text-[#60656D] mb-4">
        Please select your claim type from the options below
      </p>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("Out Patient (OP)")}
      >
        Out Patient (OP)
      </button>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("In Patient (IP)")}
      >
        In Patient (IP)
      </button>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("OP Medicine")}
      >
        OP Medicine
      </button>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("Optical")}
      >
        Optical
      </button>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("Maternity")}
      >
        Maternity
      </button>
      <button
        className="w-full text-left font-semibold mb-3 border rounded p-3 text-sm"
        onClick={() => handleSelectClaimType("Dental")}
      >
        Dental
      </button>
    </div>
  );
}

ClaimType.propTypes = {
  nextStep: PropTypes.func
};

export default ClaimType;
